<template>
    <div class="bottomright_wrap">
        <!--<div class="bottomright_wrap_title">任务执行进度 <span style="font-size:14px">今天</span></div>-->
        <div class="bottomright_wrap_title">任务执行进度</div>
        <div>
            <el-table class="top-default-margin" size="mini" :data="listData"  highlight-current-row v-loading="loading" max-height="340px" stripe element-loading-text="拼命加载中"
        :header-cell-style="{ background:'#087490',height:'24px',color:'#09dfe0',border: '1px solid #086d7f'}"
        :cell-style="{background:'#0a193d',color:'#fff',border: '1px solid transparent'}"
        style="width: 98%;">
            <el-table-column sortable prop="processName" label="工序名称"></el-table-column>
            <!-- <el-table-column  prop="deptNo" label="生产任务数"></el-table-column> -->
            <el-table-column prop="planNum" label="计划数"></el-table-column>
            <el-table-column  prop="goodNum" label="良品数"></el-table-column>
            <el-table-column  prop="nongoodNum" label="不良品数"></el-table-column>
            <!-- <el-table-column  prop="editUser" label="未完成数"></el-table-column> -->
        </el-table>
        </div>
    </div>
</template>

<script>
import { taskGetList} from '@/api/basicData';
export default {
    data() {
        return {
            // tableData: [{deptName:"名称1"},{deptName:"名称2"},{deptName:"名称3"}],
            listData:[],
            form:{},
            loading:false,
            userData:JSON.parse(window.localStorage.getItem('userdata')),
            // 分页参数
            pageparm: {
              currentPage: 1,
              pageSize: 10,
              total: 10
            },
            params:{
              condition: {
              },
              currentPage: 1,
              pageSize: 10,
            },
            timer:null
        }
    },
    created(){
      this.params['currentPage'] = 1;
      this.params['pageSize'] = 10;
      this.getdata();
      this.timer = setInterval(() => {
        this.getdata();
      }, 10000)
    },
    beforeDestroy() {
      if(this.timer) {
        clearInterval(this.timer);
      }
    },
    mounted() {
    },
    methods: {
      getdata() {
        this.loading = true
        this.form.factoryId = this.userData.factoryId;
        this.params['condition'] =this.form;
        taskGetList(this.params).then(res => {
          if(res.code == 200){
            this.pageparm = res.data;
            this.listData = res.data.list;
          }else{
            this.$message.error('查询失败！')
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err)
        })
      },
    }
}
</script>

<style scoped>
.bottomright_wrap{
    width: 100%;
    height: 100%;
    padding: 2%;
    color: #fff;
    font-size: 12px;
    box-sizing: border-box;
}
.bottomright_wrap_title {
    width: 92%;
    color: #04f9fe;
    font-size: 16px;
    margin-top: 5px;
    margin-bottom: 10px;
    margin-left: 10px;
    padding-bottom: 5px;
    font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/views/workshopSignage/workshopSignage/components/bottomright.vue